import {
  collection,
  getDocs,
  query,
  orderBy,
  where,
  Timestamp,
} from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { db, functions } from "../firebase-config";

export interface FeedbackRecord {
  id: string;
  userId: string;
  userEmail: string;
  subject: string;
  message: string;
  context: {
    documentSnippet: string | null;
    lastQuery: string | null;
  } | null;
  status: "open" | "responded" | "closed";
  createdAt: Timestamp;
  response: string | null;
  respondedAt: Timestamp | null;
  respondedBy: string | null;
  readByUser: boolean;
}

export async function getFeedback(
  statusFilter?: string
): Promise<FeedbackRecord[]> {
  let q;

  if (statusFilter && statusFilter !== "all") {
    q = query(
      collection(db, "feedback"),
      where("status", "==", statusFilter),
      orderBy("createdAt", "desc")
    );
  } else {
    q = query(
      collection(db, "feedback"),
      orderBy("createdAt", "desc")
    );
  }

  const snapshot = await getDocs(q);
  return snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  })) as FeedbackRecord[];
}

export async function respondToFeedback(
  feedbackId: string,
  response: string
): Promise<void> {
  const fn = httpsCallable(functions, "respondToFeedback");
  await fn({ feedbackId, response });
}
